import { render, staticRenderFns } from "./PlainButton.vue?vue&type=template&id=1c9025be&scoped=true&"
import script from "./PlainButton.vue?vue&type=script&lang=js&"
export * from "./PlainButton.vue?vue&type=script&lang=js&"
import style0 from "./PlainButton.vue?vue&type=style&index=0&id=1c9025be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9025be",
  null
  
)

export default component.exports